export const globalPopup = (title, show, buttons, content) => {
  let event = new Event("GLOBAL_POPUP");

  window.GLOBAL_POPUP = {
    title: title,
    buttons: buttons,
    show: show,
    content: content,
  };

  window.dispatchEvent(event);
};

export const closeGlobalPopup = () => {
  let event = new Event("GLOBAL_POPUP");

  window.GLOBAL_POPUP = {
    title: "",
    buttons: [],
    show: false,
    content: "",
  };

  window.dispatchEvent(event);
};
